import { render, staticRenderFns } from "./InfoAboutPlanModal.vue?vue&type=template&id=9f3d02dc&"
import script from "./InfoAboutPlanModal.vue?vue&type=script&lang=js&"
export * from "./InfoAboutPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports